<template>
  <div class="c-apply-schedule" @click="close">
    <div :class="{'hidden': !item.firedDate}" class="pinned">
      <n-button v-if="item.firedDate" class="tool-btn" @click.stop="unFire">Отменить увольнение</n-button>
    </div>

    <n-button v-if="!item.firedDate" class="tool-btn" @click.stop="show = true">Уволить сотрудника</n-button>

    <div v-if="show" class="c-add-visit">
      <n-loader :loading="$var('load')" />
      <div class="form" @click.stop>
        <div class="input-place">
          <div class="title">Дата увольнения</div>
          <c-date-picker :date.sync="date" />
        </div>
        <div class="input-place flex">
          <c-checkbox :checked.sync="isNeedWork" />
          <div class="title">
            Нужна отработка дня увольнения
          </div>
        </div>
        <div class="buttons">
          <n-button class="cancel" @click="close">Отмена</n-button>
          <n-button class="agree" @click="fire">Применить</n-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CApplySchedule',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      date: new Date(),
      isNeedWork: false,
    }
  },
  created() {
  },
  methods: {
    close() {
      this.show = false
    },
    fire() {
      this.$var('load', true)
      $api.users.fireUser(this.item.id, {
        firedDate: $app.date.format(this.date, 'date'),
        isNeedWork: this.isNeedWork,
      }).then(() => {
        this.$emit('done')
        this.close()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    unFire() {
      this.$var('load', true)
      $api.users.unFireUser(this.item.id).then(() => {
        this.$emit('done')
        this.close()
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.c-apply-schedule {
  display: flex;
  align-items: center;
  .pinned-schedule {
    height: 48px;
    background-color: #ffffff;
    color: var(--primary);
    border-radius: 12px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    font-weight: 600;
  }
  .pinned {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.hidden {
      opacity: 0  ;
    }
  }
  .date-picker {
    width: 100%;
  }

  .c-add-visit {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: #00000080;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 15px;
  }
  :deep() {
    .n-button {
      height: 48px;
      background-color: #ffffff;
      color: var(--primary);
      border-radius: 12px;
      border: 1px solid var(--primary);
      font-weight: 700;
      &.cancel {
        background-color: #ffffff;
        color: var(--primary);
        font-weight: 700;
        border: 1px solid var(--primary);
      }
      &.agree {
        background-color: var(--primary);
        color: #ffffff;
        font-weight: 700;
        border: 1px solid var(--primary);
      }
    }
  }
  .form {
    padding: 15px;
    z-index: 1001;
    min-width: 400px;
    border-radius: 16px;
    background-color: #FFFFFF;
    .title {
      font-size: 16px;
      color: #000000;
      font-weight: 500;
      &.main {
        margin-bottom: 15px;
      }
    }
  }

  .input-place {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 20px;
    &.flex {
      flex-direction: row;
      justify-content: left;
    }
    :deep() {
      .calendar-head {
        margin-left: 0;
      }
      .custom-checkbox {
        margin-bottom: 0;
        .check {
          width: 24px;
          height: 24px;
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
    }

    .radio-group {
      display: flex;
      gap: 16px;
    }

    .radio-item {
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;
    }

    .label {
      font-size: 14px;
      color: #000;
    }


    .title {
      flex: 0.8;
      min-width: 100px;
      margin-right: 15px;

    }

    .n-input {
      flex: 1;
      margin: 5px 0;

    }

    .n-select {
      flex: 1;

      ::v-deep {
        .vs__dropdown-toggle {
          border: none;
          border-radius: 16px;
          height: 48px;
          margin: 3px 0;
          padding: 0 6px;
        }

        .vs__selected {
          height: 40px;
          border: 1px solid var(--primary);
          border-radius: 12px;
        }
      }

    }
  }
}
</style>
